/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from "prop-types";

const Mobile = ({
	title, isSelected, onClick, isAbsolute,
}) => (
	<>
		<div
			className="container-checkbox-mobile"
			onClick={onClick}
		>
			<div
				className={
					isSelected
						? "checkbox-icon selected"
						: "checkbox-icon"
				}
			/>
			{title && (
				<span
					className="checkbox-text"
				>
					{title}
				</span>
			)}
			<style jsx>
				{`
          .container-checkbox-mobile {
            display: flex;
            align-items: ${title ? "flex-start" : "center"};
            justify-content: ${title ? "flex-start" : "flex-end"};
            border: 0;
            cursor: pointer;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            box-sizing: border-box;
            flex-direction: row;
            flex-wrap: wrap;
          }
          .container-checkbox-mobile .checkbox-text {
            font-size: 14px;
            padding-left: 25px;
            flex-direction: column;
            flex: 1;
          }
          .container-checkbox-mobile .checkbox-icon {
            ${isAbsolute ? "position: absolute;" : "position: relative;"}
            width: 15px !important;
            height: 15px !important;
            border: 1px solid #000;
          }
          .container-checkbox-mobile .checkbox-icon.selected {
            background: #000;
          }
          .container-checkbox-mobile .checkbox-icon.selected:after {
            width: 5px;
            height: 9px;
            position: absolute;
            border: solid #fff;
            border-width: 0px 2px 2px 0px;
            margin: 1px 0px 0px 4px;
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
            content: "";
            display: inline-block;
          }
        `}
			</style>
		</div>
	</>
);

Mobile.propTypes = {
	title: PropTypes.string,
	isSelected: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.number,
	]).isRequired,
	onClick: PropTypes.func.isRequired,
	isAbsolute: PropTypes.bool.isRequired,
};

export default Mobile;
